module.exports = __webpack_public_path__ + "static/7impel-ea62ac76efeb2c6b74cc74b31514bfc5.jpg";